import { connect } from 'react-redux';

import { resetGroupAndCategory, fetchGroups, fetchGroupCategories, fetchProductsByGroup, fetchProductsByCategory, fetchProducts, selectProduct, resetCurrentProduct, setGroupCategory, attachDocument, fetchQuickAccess } from '../../actions/products_actions';
import { setOriginPage } from '../../actions/inventories_actions';

import Products from '../../components/Products/products';

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    products: state.products.all,
    currentProduct: state.products.currentProduct,
    isLoading: state.products.isLoading,
    error: state.products.error,
    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    currentCategoryGroup: state.products.currentCategoryGroup,
    userType: state.auth.userType,
    userPermissions: state.auth.userPermissions,
    product: state.products.product,
  };
}

export default connect(mapStateToProps, { setOriginPage, resetGroupAndCategory, fetchGroups, fetchGroupCategories, fetchProductsByGroup, fetchProductsByCategory, fetchProducts, selectProduct, resetCurrentProduct, setGroupCategory, attachDocument, fetchQuickAccess })(Products);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/products.jsx